import { useLocation } from 'react-router-dom';
import { TabsContainer } from '@/components/TabView/Tabs';

export default function SearchTabView() {

  const items = [
    {
      label: 'All',
      value: 'all',
      to: 'all',
    },
    {
      label: 'Files',
      value: 'files',
      to: 'files',
    },
    {
      label: 'Folders',
      value: 'folders',
      to: 'folders',
    },
  ];

  const location = useLocation();

  const currentTab = [
    'all',
    'files',
    'folders',
  ].find((tab) => location.pathname.endsWith(`/${tab}`));

  return (
    <TabsContainer items={items} currentTab={currentTab} />
  );
}

export { SearchTabView };